import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTitle } from '../../context/TitleContext';
import { Row, Col } from 'react-bootstrap';
import AddProduct from './components/AddProduct';
import '../../styles/products.scss';

const ProductEdit = () => {
  const { id } = useParams();
  const { setTitle } = useTitle();

  useEffect(() => {
    setTitle('Modifier le Produit');
  }, [setTitle]);

  // TODO: Fetch product data by id and pass to components

  return (
    <div className="product-edit-page">
      <Row className="g-3">
        <Col xl={12} lg={12}>
          <AddProduct isEdit={true} productId={id} />
        </Col>
      </Row>
    </div>
  );
};

export default ProductEdit;
